// src/pages/Home.jsx
import React from "react";
import { useInView } from "react-intersection-observer";
import Image_Exported from "../assets/ImageExporter";
import TyperOnScroll from "../../utils/TyperOnScroll";

export default function Menifesto() {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <div>
      <div className="home-card-container">
        <div
          ref={ref1}
          className={`card-contain-h-1 reveal ${inView1 ? "show" : ""}`}
        >
          <div className="card-h-overlay-1">
            <div className="imag-h-overlay-1">
              <img src={Image_Exported["self-png_2"]} alt="" className="img-card-h-1" />
            </div>
          </div>
          <div className="h-c-text-contain">
            <h4 className="title-card-h">Frontend Enthusiast</h4>
            <TyperOnScroll
              className="caption-card-h"
              text="Skilled in building responsive, interactive, and user-friendly UI using modern frameworks and libraries."
              threshold={0.2}
              typeSpeed={55}
              startDelay={160}
            />
          </div>
        </div>

        <div
          ref={ref2}
          className={`card-contain-h-2 reveal ${inView2 ? "show" : ""}`}
        >
          <div className="card-h-overlay-2">
            <div className="imag-h-overlay-2">
              <img src={Image_Exported["self-png_3"]} alt="" className="img-card-h-2" />
            </div>
          </div>
          <div className="h-c-text-contain-2">
            <h4 className="title-card-h">Backend Architect</h4>
            <TyperOnScroll
              className="caption-card-h"
              text="Expert in creating robust, scalable APIs and server-side logic for seamless application performance."
              threshold={0.2}
              typeSpeed={55}
              startDelay={180}
            />
          </div>
        </div>

        <div
          ref={ref3}
          className={`card-contain-h-3 reveal ${inView3 ? "show" : ""}`}
        >
          <div className="card-h-overlay-3">
            <div className="imag-h-overlay-3">
              <img src={Image_Exported["self-png_1"]} alt="" className="img-card-h-3" />
            </div>
          </div>
          <div className="h-c-text-contain">
            <h4 className="title-card-h">Database Handler</h4>
            <TyperOnScroll
              className="caption-card-h"
              text="Proficient in designing efficient database structures, ensuring data integrity, and optimizing queries for performance."
              threshold={0.2}
              typeSpeed={55}
              startDelay={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
